document.addEventListener('DOMContentLoaded', function(event) {
  var elementMapScroll = document.querySelector('.onboarding-nav--nav');
  var pointer = document.querySelector('.nav-link--active'); 
  var menu_position = pointer.dataset.menu; 
  var menu_element = document.querySelector(menu_position);
  var limit_position = pointer.dataset.index;

  var listMenuBeginner = document.querySelectorAll('.level-links--beginner ul li a');
  var listMenuIntermediate = document.querySelectorAll('.level-links--intermediate ul li a');
  var listMenuAdvanced = document.querySelectorAll('.level-links--advanced ul li a');
  
  
  if (menu_position == '.level-links--beginner') {
    for (let i = 0; i <= limit_position; i++) {
      listMenuBeginner[i].classList.add('visited');
    }
  }
  if (menu_position == '.level-links--intermediate') {
    listMenuBeginner.forEach((item) => {
      item.classList.add('visited');
    });
    for (let i = 0; i <= limit_position; i++) {
      listMenuIntermediate[i].classList.add('visited');
    }
  }
  if (menu_position == '.level-links--advanced') {
    listMenuBeginner.forEach((item) => {
      item.classList.add('visited');
    });
    listMenuIntermediate.forEach((item) => {
      item.classList.add('visited');
    });
    for (let i = 0; i <= limit_position; i++) {
      listMenuAdvanced[i].classList.add('visited');
    }
  }

  var {
    host, hostname, href, origin, pathname
  } = window.location;

  var linkStart = document.querySelector('#startLink');
  var linkSetup = document.querySelector('#setupLink');
  var linkTenting = document.querySelector('#tentingLink');
  var linkErgonomics = document.querySelector('#ergonomicsLink');
  var linkFirstTime = document.querySelector('#firstTimeLink');
  var linkBazecor = document.querySelector('#bazecorLink');
  var linkPimp = document.querySelector('#pimpLink');

  linkStart.addEventListener('click', function () {
    window.open('/pages/raise-unboxing', '_self');
  });
  linkSetup.addEventListener('click', function () {
    window.open('/pages/raise-set-up', '_self');
  });
  linkFirstTime.addEventListener('click', function () {
    window.open('/pages/raise-first-use', '_self');
  });
  linkBazecor.addEventListener('click', function () {
    window.open('/pages/raise-configuration', '_self');
  });
  linkTenting.addEventListener('click', function () {
    window.open('/pages/raise-tenting-kit-set-up', '_self');
  });
  linkErgonomics.addEventListener('click', function () {
    window.open('/pages/raise-ergonomics', '_self');
  });
  linkPimp.addEventListener('click', function () {
    window.open('/pages/raise-customization', '_self');
  });
  

  console.log(pathname);
  switch(pathname) {
    case '/pages/raise-unboxing' :
      linkStart.classList.add('active');
      break;
    case '/pages/raise-set-up' :
      linkSetup.classList.add('active');
      break;
    case '/pages/raise-first-use' :
      linkFirstTime.classList.add('active');
      break;
    case '/pages/raise-configuration' :
      linkBazecor.classList.add('active');
      break;
    case '/pages/raise-tenting-kit-set-up' :
      linkTenting.classList.add('active');
      break;
    case '/pages/raise-ergonomics' :
      linkErgonomics.classList.add('active');
      break;
    case '/pages/raise-customization' :
      linkPimp.classList.add('active');
      break;
    default:
      linkStart.classList.add('active');
  }

  function setScroll() {
    var menusWidth = 0;
    var menuWrappers = document.querySelectorAll('.level-links--wrapper');
    menuWrappers.forEach((menuWrapper) => {
      menusWidth += menuWrapper.getBoundingClientRect().width;
    });
    var windowWidth = window.innerWidth;
    
    
    
    if(menusWidth > windowWidth) {
      var positionX = pointer.getBoundingClientRect().x;
      //console.log(positionX);
      elementMapScroll.scrollLeft = positionX - 128;
    }
  }
  setScroll();
  //elementMapScroll.addEventListener("scroll", event => {console.log(elementMapScroll.scrollLeft);}, { passive: true });
})
